import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Activity, TrendingUp, Users, Zap } from "lucide-react";
import { useTranslation } from "react-i18next";

interface ActivityStatsCardsProps {
  stats: {
    total24h: number;
    total7d: number;
    totalAll: number;
    activeTenantsLast7d: number;
    averagePerDay: number;
  };
}

export function ActivityStatsCards({ stats }: ActivityStatsCardsProps) {
  const { t } = useTranslation(["superadmin", "common"]);
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2 p-3 md:p-6">
          <CardTitle className="text-xs md:text-sm font-medium">{t("activityStats.last24h")}</CardTitle>
          <Zap className="h-4 w-4 text-amber-500" />
        </CardHeader>
        <CardContent className="p-3 md:p-6 pt-0">
          <div className="text-xl md:text-2xl font-bold">{stats.total24h}</div>
          <p className="text-xs text-muted-foreground">
            {t("activityStats.recentActivities")}
          </p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2 p-3 md:p-6">
          <CardTitle className="text-xs md:text-sm font-medium">{t("activityStats.last7days")}</CardTitle>
          <Activity className="h-4 w-4 text-blue-500" />
        </CardHeader>
        <CardContent className="p-3 md:p-6 pt-0">
          <div className="text-xl md:text-2xl font-bold">{stats.total7d}</div>
          <p className="text-xs text-muted-foreground">
            {t("activityStats.averagePerDay", { count: stats.averagePerDay })}
          </p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2 p-3 md:p-6">
          <CardTitle className="text-xs md:text-sm font-medium">{t("activityStats.totalActivities")}</CardTitle>
          <TrendingUp className="h-4 w-4 text-green-500" />
        </CardHeader>
        <CardContent className="p-3 md:p-6 pt-0">
          <div className="text-xl md:text-2xl font-bold">{stats.totalAll}</div>
          <p className="text-xs text-muted-foreground">
            {t("activityStats.sinceBeginning")}
          </p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2 p-3 md:p-6">
          <CardTitle className="text-xs md:text-sm font-medium">{t("activityStats.activeTenants")}</CardTitle>
          <Users className="h-4 w-4 text-purple-500" />
        </CardHeader>
        <CardContent className="p-3 md:p-6 pt-0">
          <div className="text-xl md:text-2xl font-bold">{stats.activeTenantsLast7d}</div>
          <p className="text-xs text-muted-foreground">
            {t("activityStats.last7daysShort")}
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
